function SavingsGuaranteeCheckmarkIcon({ width }) {
    return (
        <svg
            width={width}
            height={width}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <path
                d="M13.5195 3.55957C14.9101 0.539228 18.7016 -0.477063 21.416 1.44336C23.2554 2.74457 25.6531 2.95431 27.6904 1.99219C30.697 0.572529 34.2547 2.23144 35.0996 5.44727C35.6722 7.62632 37.3737 9.3278 39.5527 9.90039C42.7686 10.7453 44.4275 14.303 43.0078 17.3096C42.0457 19.3469 42.2554 21.7446 43.5566 23.584C45.4771 26.2984 44.4608 30.0899 41.4404 31.4805C39.394 32.4227 38.0137 34.3944 37.8281 36.6396C37.5545 39.9534 34.3393 42.2052 31.1318 41.3291C28.9583 40.7354 26.6333 41.3581 25.0479 42.959C22.7083 45.3215 18.7983 44.9797 16.9043 42.2471C15.6209 40.3951 13.4389 39.3777 11.1953 39.585C7.88468 39.8906 5.1094 37.1153 5.41504 33.8047C5.62234 31.5611 4.60488 29.3791 2.75293 28.0957C0.0203166 26.2017 -0.321466 22.2917 2.04102 19.9521C3.64193 18.3667 4.26464 16.0417 3.6709 13.8682C2.79482 10.6607 5.04663 7.44553 8.36035 7.17188C10.6056 6.98631 12.5773 5.606 13.5195 3.55957Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.931662"
            />
            <path
                d="M31 16.456L19.2646 34.1358C19.1629 34.3949 18.9935 34.6198 18.7755 34.7852C18.2206 35.1476 17.5344 34.6568 17.0525 34.1962L10 27.4532C10 27.4532 10.606 24.531 11.4601 24.8104C12.3143 25.0897 17.1182 30.315 17.3956 29.5524C17.6731 28.7897 26.9919 13.8132 27.9921 13.9114C28.9923 14.0095 31 16.456 31 16.456Z"
                fill="#F594A4"
                stroke="#2D2D2D"
                strokeWidth="0.93"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.9712 11.7673C31.551 10.5855 32.7754 7.93042 32.7754 7.93042"
                stroke="#2D2D2D"
                strokeWidth="0.931662"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.941 15.0696C35.7559 14.8186 37.5377 14.1971 37.5377 14.1971"
                stroke="#2D2D2D"
                strokeWidth="0.931662"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.6165 11.4198C25.2882 10.6337 24.4907 8.9082 24.4907 8.9082"
                stroke="#2D2D2D"
                strokeWidth="0.931662"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SavingsGuaranteeCheckmarkIcon;
